// extracted by mini-css-extract-plugin
export var bottomWave = "R_c6";
export var container = "R_b";
export var footerText = "R_cD";
export var middleWave = "R_c5";
export var section = "R_j";
export var subtitle = "R_cR";
export var textContainer = "R_b2";
export var title = "R_g";